import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SealCheck, ArrowRight } from "@phosphor-icons/react";
import SiteNav from "@/components/SiteNav";
import PropertyCard from "@/components/PropertyCard";
import Seo, { agentJsonLd } from "@/lib/seo";
import api from "@/lib/apiClient";

export default function SoldGallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/properties", { params: { status: "sold", source: "curated", limit: 48 } })
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-background min-h-screen">
      <Seo
        title="Sold & Closed — Recent Results"
        description="Recently sold and closed transactions handled by Lamar A. Whyte, The Whyte Glove (Real Broker NY LLC)."
        path="/sold"
        jsonLd={agentJsonLd()}
      />
      <SiteNav />
      <div className="max-w-7xl mx-auto px-6 pt-28 pb-16">
        <p className="text-brand text-xs uppercase tracking-[0.3em] mb-3">Track record</p>
        <h1 className="text-4xl md:text-5xl text-white flex items-center gap-3">
          <SealCheck size={36} weight="duotone" className="text-brand" /> Sold & closed
        </h1>

        {loading ? (
          <div className="py-24 flex justify-center"><div className="h-8 w-8 rounded-full border-2 border-brand border-t-transparent animate-spin" /></div>
        ) : items.length === 0 ? (
          <div className="py-20 text-center" data-testid="sold-empty">
            <p className="text-white/55 max-w-lg mx-auto font-light leading-relaxed">
              Closed transactions will appear here as they're added. In the meantime,
              let's talk about yours — pricing, timing, and a clear plan.
            </p>
            <Link
              to="/book"
              className="mt-6 inline-flex items-center gap-2 bg-brand text-black px-7 py-3 rounded-sm text-sm uppercase tracking-wider font-medium hover:bg-brand-hover"
            >
              Book a free call <ArrowRight size={15} weight="bold" />
            </Link>
          </div>
        ) : (
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="sold-grid">
            {items.map((p) => <PropertyCard key={p.id} property={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
